// extracted by mini-css-extract-plugin
export var containerMany = "SponsorSection-module--containerMany--hj8WN";
export var containerOne = "SponsorSection-module--containerOne--hlD69";
export var section = "SponsorSection-module--section--dWJB7";